exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".userListControl[data-v-663340d0] {\n  display: grid;\n  grid-gap: 1rem;\n}\n.userListControl > *[data-v-663340d0] {\n  grid-row: 1;\n}", ""]);

// exports
